export default __webpack_public_path__ + "static/ludwig-48ac317cbb3a77acafdc352ba17615fb.jpg";